export const fuelMap: Record<string, string> = {
  oil: 'olie',
  gas: 'gas',
  wood: 'træpiller',
  straw: 'halm',
  electricity: 'el-varme',
  pallet: 'palle',
  districtHeating: 'fjernvarme',
};
